import { defineComponent } from "vue";
import { PtButtonType, PtButtonTheme, PtButtonSize } from "@com/pt-components/pt-button/enum";
export default defineComponent({
    setup: function setup(props, param) {
        var emit = param.emit;
        var handleClick = function handleClick() {
            emit("reset");
        };
        return {
            handleClick: handleClick,
            PtButtonType: PtButtonType,
            PtButtonTheme: PtButtonTheme,
            PtButtonSize: PtButtonSize
        };
    }
});
